import _get from "lodash/get";
import { stopFlow, changeFlowStep } from "../../actions";
import { getActiveFlowState, getActiveFlowId } from "../../selectors";
import { FlowStoppedReason } from "../../constants";
import mainFlowDefs from "../../flows";
import getStep from "./get-step";

var shouldUpdateStep = function shouldUpdateStep(currentStep, nextStep) {
  return _get(currentStep, 'stepIndex') !== _get(nextStep, 'stepIndex');
};

var createFlowMiddleware = function createFlowMiddleware() {
  var flowDefs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mainFlowDefs;
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        var returnValue = next(action);
        var state = getState(); // check if there's an active flow currently

        var activeFlowState = getActiveFlowState(state);
        var activeFlowId = getActiveFlowId(state);
        if (!activeFlowState) return returnValue; // get the flow if possible

        var flow = flowDefs[activeFlowId];
        if (!flow) return returnValue; // get the step we're currently showing and what we should be showing

        var nextStep = getStep(flow, state, activeFlowState);
        var currentStep = activeFlowState.step;

        if (!currentStep && !nextStep) {
          // for web: for tracking purposes only dispatch finishFlow on the client for tracking purposes
          if (process.browser) dispatch(stopFlow(activeFlowId, FlowStoppedReason.COMPLETE));
        } else if (shouldUpdateStep(currentStep, nextStep)) {
          dispatch(changeFlowStep(activeFlowId, nextStep));
        }

        return returnValue;
      };
    };
  };
};

export default createFlowMiddleware;